var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouse = function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.397 2.85 12 2.5l-.398.349-10.2 9 .795.9L3.6 11.512V21.6h16.8V11.512l1.402 1.238.795-.9zM4.8 20.4V10.45L12 4.098l7.2 6.353V20.4H15v-7.2H9v7.2zm5.4 0v-6h3.6v6z"
  })));
};
export default SvgHouse;